import React from 'react';

const AracCuzdaniPrivacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Gizlilik Politikası</h1>
      <p className="text-center text-gray-600 mb-4">Son Güncelleme: Ağustos 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          Araç Cüzdanı uygulaması ("uygulama"), kullanıcılarının gizliliğine büyük önem verir.
          Bu gizlilik politikası, uygulamanın hangi verileri işlediğini, bu verileri nasıl kullandığını
          ve nasıl koruduğunu açıklar. Uygulama iOS ve Android platformlarında ücretsiz olarak sunulmaktadır.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Toplanan Veriler</h2>
        <p>
          Araç Cüzdanı, kişisel veri toplamamak üzere tasarlanmıştır. Uygulama sizden ad, soyad,
          telefon numarası, kimlik bilgisi, konum, rehber veya fotoğraf gibi kişisel bilgiler talep etmez.
          Uygulamada yalnızca aşağıdaki veriler işlenir:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>
            Araç ve masraf kayıtları: Kullanıcının kendi isteğiyle girdiği araç bilgileri (marka, model, plaka gibi)
            ile yakıt, bakım, sigorta, vergi ve benzeri masraf kayıtları.
          </li>
          <li>
            Teknik veriler: Uygulamanın düzgün çalışması ve hataların giderilmesi için cihaz türü,
            işletim sistemi sürümü gibi anonim teknik bilgiler.
          </li>
        </ul>
        <p>
          Uygulama hiçbir zaman konum, fotoğraf, kişi listesi veya mikrofon verisi toplamaz.
          Uygulamada herhangi bir reklam veya üçüncü taraf izleme (tracking) SDK'sı bulunmaz.
          Girilen veriler hiçbir şekilde reklam veya profilleme amacıyla kullanılmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Verilerin Kullanımı</h2>
        <p>
          İşlenen veriler yalnızca aşağıdaki amaçlarla kullanılır:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Araç masraf kayıtlarının saklanması ve cihazlar arasında senkronize edilmesi</li>
          <li>Masraf özetleri ve istatistiklerin uygulama içinde gösterilmesi</li>
          <li>Uygulama performansının iyileştirilmesi ve hataların giderilmesi</li>
        </ul>
        <p>
          Veriler hiçbir koşulda üçüncü şahıslarla paylaşılmaz, satılmaz veya kiralanmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Verilerin Saklanması ve Güvenliği</h2>
        <p>
          Uygulama verileri Google Firebase altyapısında güvenli biçimde depolanır.
          Firebase, endüstri standartlarında güvenlik önlemleri (SSL şifreleme, kimlik doğrulama,
          erişim kontrolü) uygular. Firebase hizmetlerinin veri işleme uygulamaları hakkında detaylı bilgi için{' '}
          <a
            href="https://firebase.google.com/support/privacy"
            className="text-blue-600"
            target="_blank"
            rel="noopener noreferrer"
          >
            Firebase Gizlilik ve Güvenlik
          </a>{' '}
          sayfasını inceleyebilirsiniz.
        </p>
        <p>
          Kullanıcı, verilerini istediği zaman uygulama içinden silebilir veya verilerinin tamamen
          kaldırılması için geliştiriciyle iletişime geçebilir. Veri silme talepleri en geç 30 gün
          içinde yerine getirilir.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Çocukların Gizliliği</h2>
        <p>
          Uygulama 13 yaş altı çocuklara yönelik değildir ve bilerek 13 yaş altı çocuklardan
          veri toplamaz. Böyle bir durumun fark edilmesi halinde ilgili veriler derhal silinir.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Ücretlendirme ve Değişiklik Hakkı</h2>
        <p>
          Uygulama şu anda tamamen ücretsiz olarak sunulmaktadır.
          Geliştirici, ilerleyen dönemlerde ek özellikler, abonelik sistemleri veya ücretli planlar sunma hakkını saklı tutar.
          Herhangi bir ücretlendirme değişikliğinde kullanıcılar önceden bilgilendirilecektir.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Kullanıcı Hakları</h2>
        <p>
          Kullanıcılar; verilerine erişme, verilerinin düzeltilmesini veya silinmesini talep etme
          hakkına sahiptir. Bu haklarınızı kullanmak için aşağıdaki iletişim adresinden bize ulaşabilirsiniz.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. İletişim</h2>
        <p>
          Herhangi bir soru, öneri veya veri silme talebi için bizimle iletişime geçebilirsiniz:
        </p>
        <p className="ml-4">
          E-posta: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600">hi@n1inovasyon.com</a><br />
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Değişiklikler</h2>
        <p>
          Bu gizlilik politikası zaman zaman güncellenebilir.
          En güncel sürüm uygulama içinden veya web sitemizden görüntülenebilir.
        </p>
      </div>
    </div>
  );
};

export default AracCuzdaniPrivacy;
